import "./App.css"
import {useEffect} from "react"
import {useAnalytics} from "./analytics/useAnalytics.js"
import {panels} from "./data/panels.js"
import {Button} from "./components/Button/Button.jsx";
import {HorizontalScroll} from "./components/HorizontalScroll/HorizontalScroll.jsx";
import Hero from "./components/Hero/Hero.jsx";
import Header from "./components/Header/Header.jsx";
import Showcase from "./components/Showcase/Showcase.jsx";
import Products from "./components/Products/Products.jsx";
import Why from "./components/Why/Why.jsx";
import Footer from "./components/Footer/Footer.jsx";

export default function App() {
	const {pageView} = useAnalytics()

	useEffect(() => {
		pageView("home")
	}, [pageView])

	return (
		<main>
			<Header/>
			<HorizontalScroll>
				<Hero/>
				<Showcase/>
				<Products/>
				<Why/>
				<Footer/>
			</HorizontalScroll>
		</main>
	)
}
